module.exports = __webpack_public_path__ + "img/img6.5a5827f7.png";